import Notiflix from "notiflix";

import { FolderOpenOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Collapse,
  Divider,
  Form,
  Input,
  InputNumber,
  Layout,
  Table,
  Tooltip,
  Typography,
} from "antd";
import { BOM } from "../../../../../services/definedMethod";
import { labelConfig } from "../../../customer.config";

const { TextArea } = Input;
const { Content } = Layout;
const { Panel } = Collapse;

const InterestRateChart = (props) => {
  //DECLARED VARIABLES
  const {
    onFinish,
    form,
    interestRateChartTableSource,
    setInterestRateChartTableSource,
    isManualInterestEntry,
  } = props;
  const { Text, Title } = Typography;

  const handleChargeDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.name, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = interestRateChartTableSource.filter(
          (item) => item.id !== key.id
        );
        setInterestRateChartTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const columns = [
    {
      title: "Period Type",
      dataIndex: "periodType",
    },
    {
      title: "Period From / To",
      dataIndex: "fromPeriodTo",
    },
    {
      title: "Amount Range",
      dataIndex: "amountRange",
    },
    {
      title: "Interest",
      dataIndex: "interest",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        interestRateChartTableSource.length >= 1 ? (
          <Tooltip title={`Incentives`}>
            <Button
              type="primary"
              icon={<FolderOpenOutlined />}
              // onClick={() => handleChargeDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          {labelConfig.interestRateInfo}
        </Title>
      </Divider>
      {isManualInterestEntry && (
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item name="isManualInterestEntry" valuePropName="checked">
            <Checkbox>{labelConfig.enableManualInterestEntry}</Checkbox>
          </Form.Item>
        </Col>
      )}

      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const isManualEntry = getFieldValue("isManualInterestEntry");

          return isManualEntry ? (
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label="Interest Rate"
                name="nominalAnnualInterestRate"
                rules={[
                  {
                    required: true,
                    message: "Interest rate is required",
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="Enter interest rate"
                  min={0}
                  max={100}
                  step={0.01}
                  addonAfter="%"
                />
              </Form.Item>
            </Col>
          ) : (
            <Table
              columns={columns}
              dataSource={interestRateChartTableSource}
              bordered
              pagination={{
                position: "bottomCentre",
                pageSize: "10",
              }}
            />
          );
        }}
      </Form.Item>
    </Form>
  );
};
export default InterestRateChart;
